import { connect } from 'react-redux'
import { useHotKeys } from 'Hooks'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { setEditingNode, setCreatingNode, setDetailPopup, setTableConfig } from 'Actions/explore'
import './ModalShadow.scss'

ModalShadow = ({ setEditingNode, setCreatingNode, setDetailPopup, setTableConfig, isEditingNode, isCreatingNode, currentNode, currentTable, left, screenWidth }) ->

  closeModal = ->
    setDetailPopup(undefined)
    setTableConfig(undefined)
    setCreatingNode(false)
    setEditingNode(undefined)

  useHotKeys([{
    sequence: 'esc'
    fn: closeModal
    expr: currentNode or currentTable or isCreatingNode or isEditingNode
    temporary: true
    watchers: [currentNode, currentTable, isCreatingNode, isEditingNode]
  }])

  <ReactCSSTransitionGroup
    transitionName="overlay-shadow"
    transitionEnterTimeout={150}
    transitionAppear={true}
    transitionAppearTimeout={150}
    transitionLeaveTimeout={150}
  >
    {if currentNode or currentTable or isCreatingNode or isEditingNode
      <div
        className="shadow"
        style={{
          width: screenWidth - left
          left
        }}
      />
    }
  </ReactCSSTransitionGroup>

mapStateToProps = ({ explore }) ->
  {
    currentNode: explore.detailPopupNode
    currentTable: explore.tableConfig
    isCreatingNode: explore.isCreatingNode
    isEditingNode: explore.isEditingNode
    screenWidth: explore.width
  }

export default connect(mapStateToProps, { setEditingNode, setCreatingNode, setDetailPopup, setTableConfig })(ModalShadow)
